import "esbuild-css-modules-plugin-ns-css:src/js/pages/fundingStep/fundingStep.module.css";

import { inject } from "esbuild-css-modules-plugin-ns-js:src/js/pages/fundingStep/fundingStep.module.css:injector.js";
export default new Proxy({
  "description": "fundingStep-module__description_E1YvYa__1100",
  "mobileH2": "fundingStep-module__mobileH2_E1YvYa__1100",
  "pageContainer": "fundingStep-module__pageContainer_E1YvYa__1100",
  "selectText": "fundingStep-module__selectText_E1YvYa__1100"
}, {
  get: function(source, key) {
    inject();
    return source[key];
  }
});
      